import React from 'react';
const GalleryIcon = ({width = "32", height = "33"}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.66667 8.73804H25.3333M9.33333 4.73804H22.6667M6.66667 28.738H25.3333C26.8061 28.738 28 27.5441 28 26.0714V15.4047C28 13.9319 26.8061 12.738 25.3333 12.738H6.66667C5.19391 12.738 4 13.9319 4 15.4047V26.0714C4 27.5441 5.19391 28.738 6.66667 28.738Z" stroke="#05A2DC" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    )
}

export {GalleryIcon}